<template lang="pug">
  .b2b-table-documentacion
    b2b-filters-documentacion-documentos(:filter-options='options' @updateDocumentation="refreshDocumentation")
    ods-table(
      :data='documentation.tableData',
      :start-sort='{ prop: "name", order: "ascending"}',
      style='width: 100%',
      @sort-change='orderOnServer',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='mini',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='project',
        v-if='isShowServicioDocumentacion',
        :label='$t("documentation.documentation_entity_table.project")',
        :show-overflow-tooltip='true',
        sortable='')
      ods-table-column(
        prop='name',
        v-if='isShowNombreDocumentacion',
        :label='$t("documentation.documentation_entity_table.name")',
        :show-overflow-tooltip='true',
        sortable='')
        template(slot-scope='scope')
          span(v-if='scope.row.url')
            a(:href='scope.row.url' target="_blank") {{ scope.row.name }}
          span(v-if='!scope.row.url') {{ scope.row.name }}
      ods-table-column(
        prop='category',
        v-if='isShowCategoriaDocumentacion',
        :label='$t("documentation.documentation_entity_table.category")',
        :show-overflow-tooltip='true',
        :formatter='formatterDocumentationCategory',
        sortable='')
      ods-table-column(
        prop='language',
        v-if='isShowIdiomaDocumentacion',
        :label='$t("documentation.documentation_entity_table.language")',
        :show-overflow-tooltip='true',
        :formatter='formatterDocumentationLanguage',
        sortable='')
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='125')
        template(slot-scope='scope')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('buttons.btnDownload') }}
            ods-button(
              v-if='scope.row.hasPath',
              style=' padding-left: 0px; padding-right: 0px;',
              type='neutral',
              icon-position='left'
              @click='handleDownloadDocumentationMulti(scope.row)')
              ods-icon(name='download', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              v-if='(canAdminDocumentation && scope.row.project!=null) || canAdminIndra',
              style=' padding-left: 0px; padding-right: 0px;',
              type='neutral',
              icon-position='left'
              @click='handleEdit(scope.row)')
              ods-icon(name='edit', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('documentation_detail.buttons.eraseDocument') }}
            ods-button(
              v-if='(canAdminDocumentation && scope.row.project!=null )|| canAdminIndra'
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral'
              @click='handleErase(scope.row)')
              ods-icon(name='delete', size='16')

    ods-row.b2b-table-documentacion__pagination(v-if='documentation.totalDocumentation > 0')
      ods-col.b2b-table-documentacion__pagination--left(:span='4')

        //- Paginación Tabla
      ods-col.b2b-table-documentacion__pagination--right(:span='24')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='handleSizeChange',
          @current-change='handleCurrentChangePagination',
          :current-page.sync='currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='20',
          layout='total, sizes, prev, pager, next, slot',
          :total='documentation.totalDocumentation')
    ods-dialog(
      ref='dialogAddDocumentation',
      :title='$t("documentation.dialog_add_documentation.updatetitle")',
      :visible.sync='isShowDialogAddDocumentation',
      :append-to-body='true',
      @close='handleCloseDialog',
      width='40%')
      ods-form(
        ref='formDialogAddDocumentation',
        :rules='rulesDialogAddDocumentation',
        :model='formDialogAddDocumentation',
        size='mini')
        ods-form-item(
          :label='$t("documentation.dialog_add_documentation.nombre.label")',
          prop='nombre')
          ods-input(
            v-model='formDialogAddDocumentation.nombre')
        ods-form-item(
          ref='url',
          :label='$t("documentation.dialog_add_documentation.url.label")',
          prop='url')
          ods-input(
            v-model='formDialogAddDocumentation.url')
        ods-form-item(
          :label='$t("documentation.dialog_add_documentation.project.label")',
          v-if='canAdminIndra'
          prop='servicio')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='formDialogAddDocumentation.servicio',
            filterable,
            clearable,
            :placeholder='$t("documentation.dialog_add_documentation.project.placeholder")')
            ods-option(
              v-for='option in optionsFilterService',
              :key='option.id',
              :label='option.name',
              :value='option.id')
        ods-form-item(
          :label='$t("documentation.dialog_add_documentation.categoria.label")'
          prop='categoria')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='formDialogAddDocumentation.categoria',
            filterable,
            clearable,
            :placeholder='$t("documentation.dialog_add_documentation.categoria.placeholder")')
            ods-option(
              v-for='option in optionsCategories',
              :key='option.id',
              :label='option.name',
              :value='option.id')
        ods-form-item(
          :label='$t("documentation.dialog_add_documentation.idioma.label")',
          prop='idioma')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='formDialogAddDocumentation.idioma',
            filterable,
            :placeholder='$t("documentation.dialog_add_documentation.idioma.placeholder")')
            ods-option(
              v-for='option in optionsLanguages',
              :key='option.id',
              :label='option.name',
              :value='option.id')
        ods-form-item(prop='fichero', ref='form-item-upload')
          ods-upload(
          v-model='formDialogAddDocumentation.fichero',
          ref='upload',
          action='#',
          :auto-upload='false',
          :on-change='onSuccessUpload',
          :on-remove='handleRemoveUpload',
          :file-list='fileList')
            ods-button(
              icon='ods-icon-plus',
              size='small',
              circle)
              | {{ $t('msg_generics.file_selected') }}
        ods-form-item(v-if='formDialogAddDocumentation.hasPath')
          ods-checkbox(v-model='formDialogAddDocumentation.deletefile')
            span {{ $t('documentation.dialog_add_documentation.deletefile') }}
      span.dialog-footer(slot='footer')
      ods-button.add-documentation-button(
        style='float: right;',
        type='primary',
        @click.native='onSubmitUpdateDocumentation("formDialogAddDocumentation")')
        | {{ $t('msg_generics.load_document') }}
    //- Documentos  Seleccionados
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
        div(slot='actions')
          ods-button(
            icon='ods-icon-download',
            size='small',
            circle,
            @click.native='handleDownloadDocumentationMulti')
             | {{ $t('documentation.buttons.download_multiple') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTableMenuDocumentation from './B2bTableMenuDocumentacionDocumentos'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-documentacion'
import B2bFiltersDocumentacionDocumentos from './B2bFiltersDocumentacionDocumentos'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-documentacion',
  mixins: [Utils],
  data () {
    const validaUrlFile = (rule, value, callback) => {
      if ((!this.formDialogAddDocumentation.url && !this.formDialogAddDocumentation.fichero && !this.formDialogAddDocumentation.hasPath) ||
        ((!this.formDialogAddDocumentation.url && this.formDialogAddDocumentation.deletefile))) {
        callback(new Error(this.$t('documentation.dialog_add_documentation.urlorfile_required')))
      } else {
        callback()
      }
    }
    return {
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      optionsCategories: [],
      optionsLanguages: [],
      // Paginación
      totalResults: 0,
      currentPage: 0,
      id: '',
      fileList: [],
      isShowDialogAddDocumentation: false,
      formDialogAddDocumentation: {
        servicio: null,
        nombre: null,
        url: null,
        hasPath: false,
        categoria: null,
        idioma: null,
        fichero: null,
        deletefile: false
      },
      // Reglas Validación
      rulesDialogAddDocumentation: {
        nombre: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          },
          {
            max: 50,
            message: this.$t('validations.maxlenght', { maxlenght: 50 }),
            trigger: 'change'
          }
        ],
        url: [
          { max: 50, message: this.$t('validations.maxlenght', { maxlenght: 255 }), trigger: 'change' },
          { validator: validaUrlFile, trigger: 'click' }
        ],
        idioma: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'click'
          }
        ],
        fichero: [
          { validator: validaUrlFile, trigger: 'click' }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'documentation',
      'queryDocumentation',
      'canAdminIndra',
      'canAdminDocumentation',
      'optionsFilterService',
      'optionsFilterDocumentationCategories',
      'optionsFilterLanguages',
      'isShowServicioDocumentacion',
      'isShowCategoriaDocumentacion',
      'isShowIdiomaDocumentacion',
      'isShowNombreDocumentacion'
    ])
  },

  components: {
    B2bTableMenuDocumentation,
    B2bFiltersDocumentacionDocumentos,
    B2bTableSelectRows
  },

  methods: {
    refreshDocumentation () {
      this.loading = true
      this.cleanData()
      this.$forceUpdate()
      setTimeout(() => this.loading = false, 2000) // eslint-disable-line
    },
    ...mapActions([
      'getOptionsService',
      'getDocumentation',
      'getDocumentationCategories',
      'getLanguages',
      'downloadDocumentationMultiple',
      'deleteDocument',
      'optionsFilterServiceState',
      'handleUploadDocumentation',
      'updateDocumentation',
      'queryDocumentationState',
      'optionsServicesEnabledState'
    ]),

    // Formatear categoria de la documentacion
    formatterDocumentationCategory (row, column) {
      if (row[column.property]) return this.$t('documentation_category.' + row[column.property])
      else return ''
    },

    // Formatear idioma de la documentacion
    formatterDocumentationLanguage (row, column) {
      if (row[column.property]) return this.$t('documentation_language.' + row[column.property])
      else return ''
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddDocumentation.fichero = file
      this.$refs.formDialogAddDocumentation.validateField('fichero')
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    // Reseteo al cerrar dialogo
    handleCloseDialog () {
      this.$refs.formDialogAddDocumentation.resetFields()
      this.handleRemoveUpload()
      this.formDialogAddDocumentation.fichero = null
    },
    handleEdit (row) {
      this.formDialogAddDocumentation.id = row.id
      this.formDialogAddDocumentation.servicio = row.idProject
      this.formDialogAddDocumentation.nombre = row.name
      this.formDialogAddDocumentation.url = row.url
      this.formDialogAddDocumentation.hasPath = row.hasPath
      this.formDialogAddDocumentation.categoria = row.idCategory
      this.formDialogAddDocumentation.idioma = row.idLanguage
      this.formDialogAddDocumentation.deletefile = false
      this.isShowDialogAddDocumentation = true
    },

    onSubmitUpdateDocumentation (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('onSubmitAddDocumentation!!!   ', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_attachment')
          })
          try {
            const query = {
              documentation: this.fileList[0],
              id: this.formDialogAddDocumentation.id,
              projectId: this.formDialogAddDocumentation.servicio,
              categoryId: this.formDialogAddDocumentation.categoria,
              name: this.formDialogAddDocumentation.nombre,
              url: this.formDialogAddDocumentation.url,
              languageId: this.formDialogAddDocumentation.idioma,
              deletefile: this.formDialogAddDocumentation.deletefile
            }
            await this.handleUploadDocumentation(query)
            this.$notify({
              title: this.$t('documentation_detail.notify.upload_document_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            await this.getTableContent()
          } catch (error) {
            console.log('onSubmitAddDocumentation CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.isShowDialogAddDocumentation = false
          }
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },

    async orderOnServer ({ column, order, prop }) {
      let stringSort = ''
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })
      if (order === 'descending') {
        order = 'DESC'
      } else if (order === 'ascending') {
        order = 'ASC'
      } else {
        order = 'ASC'
      }
      if (!prop) {
        prop = 'name'
      } else if (prop === 'category') {
        prop = 'documentationCategory'
      }

      stringSort = prop + ',' + order
      this.queryDocumentation.sort = stringSort

      try {
        await this.queryDocumentationState(this.queryDocumentation)
        dataQuery.query = this.queryDocumentation
        const response = await this.getDocumentation(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    // Descarga múltiple de pdf
    async handleDownloadDocumentationMulti (currentRowId) {
      console.log('currentRowId.id: ', currentRowId.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('documentation_detail.load.download')
      })
      try {
        let idList = this.multipleSelectionIds
        if (currentRowId.id) {
          idList = [currentRowId.id]
        }
        const filename = await this.downloadDocumentationMultiple(idList)
        this.$notify({
          title: this.$t('msg_generics.download_files_ok', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Ir al detalle */
    handleGoDetail () {
      sessionStorage.setItem('documentationName', this.currentRow.name)
      router.push({
        name: 'documentacion-documento-detail',
        params: {
          idDocumentation: this.currentRow.id,
          documentationName: this.currentRow.name
        }
      })
    },

    async handleErase () {
      this.$confirm(this.$t('documentation_detail.confirm.title_delete_documentation'), {
        confirmButtonText: this.$t('documentation_detail.confirm.confirm_button_delete_documentation'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('documentation_detail.load.delete_document')
        })
        try {
          await this.deleteDocument(this.currentRow.id)
          this.$notify({
            title: this.$t('documentation_detail.notify.delete_document_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          this.getTableContent()
        } catch (error) {
          console.log('removeDocument CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuDocumentation />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryDocumentation.size = val
        dataQuery.query = this.queryDocumentation
        const response = await this.getDocumentation(dataQuery)
        console.log('getDocumentation 6')
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryDocumentation.page = val - 1
        dataQuery.query = this.queryDocumentation
        const response = await this.getDocumentation(dataQuery)
        console.log('getDocumentation 7')
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },

    async getTableContent () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const dataQuery = { query: {} }
        dataQuery.query = this.queryDocumentation
        const response = await this.getDocumentation(dataQuery)
        this.totalResults = response.data.totalElements
        this.currentPage = response.data.number + 1
      } catch (error) {
        console.log('getDocumentation CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    }
  },

  async created () {
    this.options = filters.filters

    const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC' }
    const optionsFilterServicePromise = this.getOptionsService(dataQueryProj)
    const optionsCategoriesPromise = this.getDocumentationCategories()
    const optionsLanguagesPromise = this.getLanguages()

    this.optionsCategories = await optionsCategoriesPromise
    if (this.optionsCategories) {
      for (let index = 0; index < this.optionsCategories.length; index++) {
        this.optionsCategories[index].name = this.$t('documentation_category.' + this.optionsCategories[index].name)
      }
      this.optionsCategories.sort((a, b) => (a.name.toUpperCase().localeCompare(b.name.toUpperCase())))
    }

    this.optionsLanguages = await optionsLanguagesPromise
    if (this.optionsLanguages) {
      for (let index = 0; index < this.optionsLanguages.length; index++) {
        this.optionsLanguages[index].name = this.$t('documentation_language.' + this.optionsLanguages[index].name)
      }
      this.optionsLanguages.sort((a, b) => (a.name.toUpperCase().localeCompare(b.name.toUpperCase())))
    }

    const optionsFilterService = await optionsFilterServicePromise
    await this.optionsServicesEnabledState(optionsFilterService)

    await this.getTableContent()
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-documentacion {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}

</style>
